import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import {Map as MapIcon } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import { Button, CardActionArea } from '@mui/material';

export default function MediaCard({ title, layer, setMapLayer, openData, setLabel, tag, setWilayah, value, setSource, setCollapsedLegenda }) {

  function addAndGo(layer) {
   
    setMapLayer(oldArray => [...oldArray, { id: layer, title: title, server: "geoserver", tipe: 'wms', url: "https://tanahair.indonesia.go.id/geoserver/dashboard/wms", geom:'', layer: layer, metadata: false, table: false, visible: true, opacity: 1, tag: tag, value: value }])
    openData();
    setLabel(title);
    setWilayah(tag);
    if (value == 0){
      setSource("PK 2021");
    } else if (value == 1){
      setSource("Verval 2022");
    } else if (value == 2){
      setSource("PK 2022");
    }
    //setCollapsedLegenda(false);
  }
  
    return (
      <Card sx={{
        width: 200,
        margin: 1,
        display: 'flex',
        flexDirection: 'column',
        }} key={layer}>
        <CardActionArea onClick={()=>addAndGo(layer)}>
            <CardMedia
                    sx={{
                        width: 200,
                        height: 100,
                    }}
                    image={ process.env.PUBLIC_URL +'/thumbs/'+layer+'.jpg'} 
                      //layer? "https://tanahair.indonesia.go.id/geoserver/dashboard/wms/reflect?layers=dashboard%3A"+layer+"&width=384":"https://geoservices.big.go.id/raster/rest/services/IMAGERY/FU_2011_KotaPekanbaru/ImageServer/info/thumbnail"}
                    //}
                      title={title}
            />
          <CardContent>
            <Typography gutterBottom variant="p" component="div">
              {title}
            </Typography>
          </CardContent>
        </CardActionArea>
       
      </Card>
    );
}
